/*** IMPORTS FROM imports-loader ***/
var define = false;

var prefixCounts = new Map();
export function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}
//# sourceMappingURL=makeUniqueId.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/utilities/common/makeUniqueId.js
// module id = 741
// module chunks = 0